/**
 * @file gridPageBleed.ts
 * @brief Page-root class helper for grid-shell pages.
 *
 * @details
 * Split out of `GridBlock.tsx` (02-08-2026). That module renders the grid
 * components, and a module exporting **both** a component and a value loses
 * React Fast Refresh — `@vitejs/plugin-react` can no longer hot-swap it, so an
 * edit to any grid primitive full-reloaded the page. This helper is imported by
 * ~35 page roots, which made `GridBlock.tsx` one of the most-edited modules in
 * the panel to lose it.
 *
 * @references
 * - features/analytics/components/GridBlock.tsx
 *
 * @author DES
 * @date 02-08-2026
 */

import { cn } from "@/shared/theme/cn";

/** Page root helper — vertical page spacing (rail is already unpadded). */
export function gridPageBleedClass(className?: string): string {
  return cn(className);
}
